import React from 'react';
import PropTypes from 'prop-types';
import logoLong from '@assets/images/logo_and_name.png';

LogoLong.propTypes = {
  className: PropTypes.string,
  imgClassName: PropTypes.string
};

export default function LogoLong(props) {
  const { className, imgClassName } = props;

  return (
    <div className={className}>
      <img className={imgClassName} src={logoLong} alt="CommunityShare" />
    </div>
  );
}
